import React from 'react';
import { Field } from 'formik';

import { InputUI, FormErrorUI, FormLabelUI, AutoCompleteSelectUI } from '../../Interface';

export const TaskListTemplateFields = ({
  viewField,
  values,
  errors,
  setFieldValue,
  validateField,
  autocompleteOptions,
}) => {
  return (
    <div className="grid grid-cols-4 gap-x-4 mx-4 mb-5">
      <div className="col-span-4 md:col-span-2">
        <Field
          type="text"
          name="name"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Feladat lista neve" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.name} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.name !== '' }}
        />
      </div>
      <div className="col-span-5 md:col-span-2">
        <Field
          type="autocomplete"
          name="projectTypeId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Projekt Típus" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.projectTypeId} />}
          onChange={(_e, newVal) => {
            setFieldValue('projectTypeId', newVal?.value ?? null).then(() => {
              validateField('projectTypeId');
            });
          }}
          InputLabelProps={{ shrink: values.projectTypeId !== '' }}
          selectedValue={values.projectTypeId}
          dataset={autocompleteOptions.projectType}
          disabled={viewField}
        />
      </div>
    </div>
  );
};
